import React from "react";
import AuthorizedPage from "../../models/base/AuthorizedPage";
import PageDefinitions from "../../providers/PageDefinitions";
import {Link, PageContainer, PageHeader, PageRow} from "@reapptor-apps/reapptor-react-components";
import Localizer from "../../localization/Localizer";

import styles from "./Admin.module.scss"
import { BasePageParameters } from "@reapptor-apps/reapptor-react-common";

export interface IAdminParams extends BasePageParameters {
}
export default class Admin extends AuthorizedPage {
    public render(): React.ReactNode {
        return (
            <PageContainer className={styles.admin}>
                <PageHeader title={Localizer.topNavAdminManagement} subtitle={this.getContext().username}/>
                <PageRow>
                    <div className="col">
                        <div className={styles.menu}>
                            <Link className={styles.menuLink} route={PageDefinitions.userManagementRoute}>{Localizer.userManagementPageTitle}</Link>
                            <Link className={styles.menuLink} route={PageDefinitions.applicationSettingsRoute}>{Localizer.applicationSettingsPageTitle}</Link>
                            <Link className={styles.menuLink} route={PageDefinitions.adminConsoleRoute}>{Localizer.adminConsolePageTitle}</Link>
                        </div>
                    </div>
                </PageRow>
            </PageContainer>
        );
    }
}